import { Component } from '@theme/component';
import { debounce, onDocumentLoaded } from '@theme/utilities';
import { CartAddEvent, ThemeEvents } from '@theme/events';



class CartDrawerComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    // ==== Refs ====
    this.dialog = this.querySelector('[ref="dialog"]');
    this.closeButton = this.querySelector('[ref="closeButton"]');
    this.header = document.querySelector('header-component');

    // ==== Event listeners ====
    this.closeButton?.addEventListener('click', () => this.close());
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd, { capture: true });

    // ==== HOVER ====
    document.addEventListener(ThemeEvents.cartHover, this.#handleCartHover);

    // Hover sur le drawer lui-même
    this.dialog?.addEventListener('pointerenter', this.cancelClose);
    this.dialog?.addEventListener('pointerleave', this.handleDialogLeave);

    if (window.cartDrawerShouldOpen) {
      this.open(false);
      window.cartDrawerShouldOpen = false;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.closeButton?.removeEventListener('click', () => this.close());
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd, { capture: true });
    document.removeEventListener(ThemeEvents.cartHover, this.#handleCartHover);

    this.dialog?.removeEventListener('pointerenter', this.cancelClose);
    this.dialog?.removeEventListener('pointerleave', this.handleDialogLeave);
  }

  handleDialogLeave = () => {
    if (this.dialog?.classList.contains('cart-drawer--hover')) {
      this.#debouncedClose();
    }
  };

  // ==== Debounced close ====
  #debouncedClose = debounce(() => this.close(), 300);

  scheduleClose = () => {
    if (this.dialog?.classList.contains('cart-drawer--hover')) {
      this.#debouncedClose();
    }
  };

  cancelClose = () => {
    this.#debouncedClose.cancel();
  };

  // ==== Hover handler ====
  #handleCartHover = (event) => {
    if (!event.detail) return;

    if (event.detail.state === 'enter') {
      this.cancelClose();
      this.open(true);
    } else if (event.detail.state === 'leave') {
      if (this.dialog?.classList.contains('cart-drawer--hover')) {
        this.#debouncedClose();
      }
    }
  };

  // ==== Open / Close ====
  open(isHover = false) {
     // Si c'est un événement (ex: pointerenter appelé via HTML)
    if (isHover && isHover.type) {
      if (isHover.type === 'pointerenter' && isHover.pointerType === 'touch') {
        // On ignore le survol tactile. On ne fait RIEN (surtout pas fermer le menu ici),
        // on attend que l'événement CLICK prenne le relais pour exécuter la logique complète.
        return;
      }
      isHover = (isHover.type === 'pointerenter' || isHover.type === 'mouseenter');
    }

    this.cancelClose();

    // 1. Ouvrir LE PANIER
    this.dialog?.classList.add('is-open');
    this.dialog?.setAttribute('aria-hidden', 'false');
    this.header?.classList.add('header--inherit-color-scheme-on-menu-open');
    // document.body.style.overflow = 'hidden';
    document.documentElement.setAttribute('scroll-lock', 'true');

    // Gestin hover
    if (isHover) {
      this.dialog?.classList.add('cart-drawer--hover');
    } else {
      this.dialog?.classList.remove('cart-drawer--hover');
    }

    // 2. Fermer LE MENU DRW mais APRÈS que le panier soit monté
    const headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer && headerDrawer.isOpen) {
      headerDrawer.close();
    }
  }

  close() {
    this.dialog?.classList.remove('is-open');
    this.dialog?.setAttribute('aria-hidden', 'true');

    // document.body.style.overflow = '';
    document.documentElement.removeAttribute('scroll-lock');
    this.header?.classList.remove('header--inherit-color-scheme-on-menu-open');
  }

  // ==== Auto open on add ====
  #handleCartAdd = () => {
    if (!this.hasAttribute('auto-open')) return;

    window.cartDrawerShouldOpen = true;

    const isMobile = window.matchMedia('(max-width: 759px)').matches;
    queueMicrotask(() => {
      requestAnimationFrame(() => {
        this.open(!isMobile);
      });
    });
  };
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
